/* eslint-disable
    @typescript-eslint/no-unused-vars,
    prettier/prettier,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'lodash';
import $r from 'js/core_pre_webpack/routes';
const Aedu = window.Aedu || {};

class ScribdDocumentTracker {
  static initClass() {

    this.loadedAt = new Date();
  }

  constructor(attachmentId, docView) {
    let throttleInterval;
    this.attachmentId = attachmentId;
    this.docView = docView;
    _.extend(this, Backbone.Events);

    this.events = [];
    this.pagesViewed = {};

    this.listenTo(this.docView, 'docReady', this.recordDocumentReady);
    this.listenTo(this.docView, 'pageChanged', this.recordPageChange);
    $(window).on('beforeunload', () => this.recordUnload());

    if ((window.navigator.sendBeacon != null) && (window.FormData != null)) {
      // Recent Chrome & Firefox, as of April 2016
      //
      // TODO Adblockers may disable sendBeacon; should we try to detect this
      // and fall back to $.post?
      this.sendData = function(url, data) {
        const fd = new FormData();
        _.each(data, (val, key) => fd.append(key, val));
        const success = navigator.sendBeacon(url, fd);
        if (!success) { return $a.log(`sendBeacon failed for: ${JSON.stringify(data)}`); }
      };
      throttleInterval = 15000;
    } else {
      // Our beforeunload handler won't usually have any effect, so send data
      // more frequently to make up for it.
      //
      // (We can't use synchronous ajax because that results in an alert window.)
      this.sendData = $.post;
      throttleInterval = 1000;
    }

    this.flushEventsThrottled = _.throttle((() => this.flushEvents()), throttleInterval);
  }

  recordDocumentReady(e) {
    this.enqueueEvent('docReady', this.docView.getPage());
    return this.flushEventsThrottled();
  }

  recordPageChange(e) {
    this.enqueueEvent('pageChanged', e.page);
    return this.flushEventsThrottled();
  }

  // This won't be 100% reliable, but that's ok, we also flush periodically
  // and this just improves our best-effort strategy
  recordUnload() {
    this.enqueueEvent('unload', this.docView.getPage());
    this.flushEvents(false);
     // Ensure void return value so browsers do not show alert box
  }

  enqueueEvent(event, page) {
    return this.events.push({
      event,
      ms_since_load: (new Date().getTime() - this.constructor.loadedAt),
      page
    });
  }

  flushEvents(async) {
    if (async == null) { async = true; }
    if (!(this.events.length > 0)) { return; }

    // Wait for hit_data to become available (in the case where it might not be
    // available until record_hit has completed, i.e. if this is a logged-out
    // visitor)
    if (!Aedu.hit_data && async) {
      setTimeout((() => this.flushEventsThrottled()), 500);
      return;
    }

    this.sendData($r.api_v0_scribd_events_path({subdomain_param: 'api'}), {
      hit: JSON.stringify(Aedu.hit_data),
      attachment_id: this.attachmentId,
      events: JSON.stringify(this.events)
    }
    );

    if (Aedu.hit_data) {
      for (const event of this.events) {
        if (event.event !== 'pageChanged') {
          continue;
        }

        if (this.pagesViewed[event.page]) {
          continue;
        }

        this.pagesViewed[event.page] = true;

        $.ajax({
          url: $r.api_v0_views_path({ subdomain_param: 'api' }),
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            hit_id: Aedu.hit_data.id,
            impression_time: new Date(),
            entity_id: this.attachmentId,
            entity_type: 17, // ImpressionEntity.AttachmentPage
            source: 'scribd_document_tracker',
            extra: {
              page: event.page,
              ms_since_load: event.ms_since_load,
            },
          }),
        });
      }
    }

    return this.events = [];
  }
}

ScribdDocumentTracker.initClass();

if (window.Aedu) {
  window.Aedu.ScribdDocumentTracker = ScribdDocumentTracker
}

export default ScribdDocumentTracker;
